import Cookies from 'js-cookie'

/**
 * Gets an existing facebook browser id (fbp) without setting or refreshing it
 * @returns The saved facebook browser id (fbp), if it is set, or undefined otherwise
 */
const getFacebookBrowserId = () => Cookies.get('_fbp') || null

export default getFacebookBrowserId
